/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ volumeText: NonNullable<unknown>, range: NonNullable<unknown> }} Wrapped_Share_Volume_BestInputs */

const en_us2_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} lifted in the week of ${i?.range}, my strongest week yet. My Pocket Gym.`)
};

const pt_br2_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantadas na semana de ${i?.range}, minha semana mais forte até agora. My Pocket Gym.`)
};

const es_419_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados en la semana del ${i?.range}, mi semana más fuerte hasta ahora. My Pocket Gym.`)
};

const pt_pt2_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados na semana de ${i?.range}, a minha semana mais forte até agora. My Pocket Gym.`)
};

const fr_fr2_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'ai soulevé ${i?.volumeText} la semaine du ${i?.range}, ma semaine la plus forte à ce jour. My Pocket Gym.`)
};

const de_de2_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} bewegt in der Woche vom ${i?.range}, meine bisher stärkste Woche. My Pocket Gym.`)
};

const it_it2_wrapped_share_volume_best = /** @type {(inputs: Wrapped_Share_Volume_BestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} sollevati nella settimana del ${i?.range}, la mia settimana più forte finora. My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "{volumeText} lifted in the week of {range}, my strongest week yet. My Pocket Gym." |
*
* @param {Wrapped_Share_Volume_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share_volume_best = /** @type {((inputs: Wrapped_Share_Volume_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Share_Volume_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share_volume_best(inputs)
	if (locale === "es-419") return es_419_wrapped_share_volume_best(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share_volume_best(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share_volume_best(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share_volume_best(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share_volume_best(inputs)
	return en_us2_wrapped_share_volume_best(inputs)
});
export { wrapped_share_volume_best as "wrapped.share_volume_best" }